import { render, staticRenderFns } from "./ViewIosProfiles.vue?vue&type=template&id=c7fb25c2&scoped=true&"
import script from "./ViewIosProfiles.vue?vue&type=script&lang=js&"
export * from "./ViewIosProfiles.vue?vue&type=script&lang=js&"
import style0 from "./ViewIosProfiles.vue?vue&type=style&index=0&id=c7fb25c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7fb25c2",
  null
  
)

export default component.exports